import React, { useState } from 'react';
import styles from './FAQ.module.css';

const FAQ = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [openItems, setOpenItems] = useState({});

  // FAQ Categories
  const categories = [
    { id: 'all', name: 'All Questions', icon: '📋', count: 24 },
    { id: 'courses', name: 'Courses', icon: '📚', count: 6 },
    { id: 'mathematics', name: 'Mathematics Optional', icon: '🧮', count: 5 },
    { id: 'upsc', name: 'UPSC', icon: '🎯', count: 4 },
    { id: 'bpsc', name: 'BPSC', icon: '🏛️', count: 3 },
    { id: 'payment', name: 'Payment & Fees', icon: '💰', count: 3 },
    { id: 'technical', name: 'Technical', icon: '💻', count: 3 }
  ];

  // FAQ Data
  const faqData = [
    // Courses Category
    {
      id: 1,
      category: 'courses',
      question: 'What courses does Exademy offer for Mathematics Optional?',
      answer: 'Exademy offers comprehensive courses for UPSC Mathematics Optional, BPSC Mathematics Optional, CSIR NET/GATE Mathematics, and Mathematics Foundation programs. We also provide chapter-wise and full syllabus test series, along with dedicated mentorship programs.',
      tags: ['courses', 'mathematics', 'upsc', 'bpsc']
    },
    {
      id: 2,
      category: 'courses',
      question: 'Are the courses available in both Hindi and English medium?',
      answer: 'Yes! For BPSC Mathematics Optional, we provide bilingual support with notes and answer evaluation in both Hindi and English. For UPSC, the primary medium is English, but doubt clearing sessions can be conducted in Hindi as well.',
      tags: ['courses', 'bpsc', 'hindi', 'medium']
    },
    {
      id: 3,
      category: 'courses',
      question: 'What is the duration of the UPSC Mathematics Optional course?',
      answer: 'Our UPSC Mathematics Optional 2026 course is 12 months long, while the 2027 batch is 18 months long for early starters. The courses include live lectures, recorded sessions, test series, and mentorship.',
      tags: ['courses', 'upsc', 'duration']
    },
    {
      id: 4,
      category: 'courses',
      question: 'Can I access recorded lectures if I miss a live class?',
      answer: 'Absolutely! All live sessions are recorded and uploaded to your dashboard within 24 hours. You can access these recordings anytime during your course validity period.',
      tags: ['courses', 'technical', 'recordings']
    },
    {
      id: 5,
      category: 'courses',
      question: 'Do you provide study material or do I need to buy books separately?',
      answer: 'We provide comprehensive printed study material (8 volumes for UPSC, 6 volumes for BPSC) delivered free to your doorstep. This covers the entire syllabus and includes solved PYQs. You don\'t need to buy any additional books.',
      tags: ['courses', 'material', 'books']
    },
    {
      id: 6,
      category: 'courses',
      question: 'Is there any foundation course for beginners?',
      answer: 'Yes, we offer a Mathematics Foundation course specifically designed for aspirants who want to build strong fundamentals before starting their optional preparation. This 8-month course covers calculus, algebra, trigonometry, and coordinate geometry.',
      tags: ['courses', 'foundation', 'beginners']
    },

    // Mathematics Optional Category
    {
      id: 7,
      category: 'mathematics',
      question: 'Is Mathematics optional scoring in UPSC?',
      answer: 'Yes, Mathematics is one of the highest scoring optionals in UPSC. The average score in Mathematics is 280-320 marks, and with structured preparation, 300+ is very achievable. In 2024, 23 of our students scored 300+ marks.',
      tags: ['mathematics', 'upsc', 'scoring']
    },
    {
      id: 8,
      category: 'mathematics',
      question: 'What is the syllabus for UPSC Mathematics Optional?',
      answer: 'UPSC Mathematics Optional consists of two papers. Paper I covers Linear Algebra, Calculus, Analytical Geometry, Differential Equations, Vector Analysis, and Dynamics. Paper II covers Algebra, Real Analysis, Complex Analysis, Linear Programming, Partial Differential Equations, Numerical Analysis, and Mechanics.',
      tags: ['mathematics', 'upsc', 'syllabus']
    },
    {
      id: 9,
      category: 'mathematics',
      question: 'How is BPSC Mathematics Optional different from UPSC?',
      answer: 'BPSC Mathematics Optional has approximately 80% syllabus overlap with UPSC, but with a different question pattern and emphasis. BPSC focuses more on Statics, Dynamics, and Vector Analysis. Our BPSC-specific course addresses these unique requirements.',
      tags: ['mathematics', 'bpsc', 'difference']
    },
    {
      id: 10,
      category: 'mathematics',
      question: 'Do I need to be a Mathematics graduate to take this optional?',
      answer: 'While a Mathematics background helps, it is not mandatory. Many successful candidates from engineering and science backgrounds have scored high in Mathematics optional with proper guidance and consistent practice.',
      tags: ['mathematics', 'eligibility', 'background']
    },
    {
      id: 11,
      category: 'mathematics',
      question: 'How many questions should I practice daily?',
      answer: 'We recommend practicing 15-20 conceptual questions daily, along with 2-3 answer writing practice questions. Our course includes daily practice problems (DPPs) with video solutions.',
      tags: ['mathematics', 'practice', 'daily']
    },

    // UPSC Category
    {
      id: 12,
      category: 'upsc',
      question: 'What is the ideal time to start Mathematics Optional preparation?',
      answer: 'For CSE 2026, starting now is ideal. For CSE 2027, you have more flexibility. We recommend 12-18 months of dedicated preparation for Mathematics optional to complete syllabus, practice extensively, and master answer writing.',
      tags: ['upsc', 'timing', 'preparation']
    },
    {
      id: 13,
      category: 'upsc',
      question: 'How many mock tests are included in the UPSC course?',
      answer: 'Our UPSC Mathematics Optional course includes 15 sectional tests and 10 full-length mock tests. Each test copy is evaluated with detailed, one-on-one video feedback.',
      tags: ['upsc', 'tests', 'mocks']
    },
    {
      id: 14,
      category: 'upsc',
      question: 'Do you provide separate guidance for UPSC interview?',
      answer: 'Yes, our mentorship program includes interview guidance sessions with former UPSC interview panel members and rank holders. This is included in the course for students who clear the Mains.',
      tags: ['upsc', 'interview', 'mentorship']
    },
    {
      id: 15,
      category: 'upsc',
      question: 'What is the success rate of Exademy students in UPSC?',
      answer: 'In the last 3 years, 75+ Exademy students have been selected in UPSC CSE with Mathematics optional. We have had 12 candidates in the top 100 ranks.',
      tags: ['upsc', 'success', 'results']
    },

    // BPSC Category
    {
      id: 16,
      category: 'bpsc',
      question: 'Is BPSC Mathematics optional conducted in Hindi?',
      answer: 'Yes, BPSC Mathematics optional can be answered in Hindi or English. We provide bilingual study material and answer evaluation in both languages.',
      tags: ['bpsc', 'hindi', 'medium']
    },
    {
      id: 17,
      category: 'bpsc',
      question: 'What is the syllabus for BPSC Mathematics Optional?',
      answer: 'BPSC Mathematics Optional includes: Paper I - Algebra, Trigonometry, Analytical Geometry, Calculus, Differential Equations, Vector Analysis; Paper II - Statics, Dynamics, Numerical Analysis, Linear Programming.',
      tags: ['bpsc', 'syllabus']
    },
    {
      id: 18,
      category: 'bpsc',
      question: 'Do you have offline center in Patna for BPSC aspirants?',
      answer: 'Yes, we have a study center in Patna where BPSC aspirants can access offline doubt clearing sessions and test series. The course content remains the same as online.',
      tags: ['bpsc', 'offline', 'patna']
    },

    // Payment & Fees Category
    {
      id: 19,
      category: 'payment',
      question: 'What are the payment options available?',
      answer: 'We accept all major credit/debit cards, UPI (Google Pay, PhonePe, Paytm), net banking, and EMI options through partner banks. You can also pay via demand draft at our centers.',
      tags: ['payment', 'fees', 'emi']
    },
    {
      id: 20,
      category: 'payment',
      question: 'Do you offer any scholarships or discounts?',
      answer: 'Yes, we offer merit-cum-means scholarships up to 100% for deserving candidates. We also have early bird discounts, group discounts (3+ students), and special offers for defence personnel and economically weaker sections.',
      tags: ['payment', 'scholarship', 'discount']
    },
    {
      id: 21,
      category: 'payment',
      question: 'What is your refund policy?',
      answer: 'We offer a 100% money-back guarantee if you are not satisfied within the first 7 days of course access. No questions asked. After 7 days, refunds are processed on a pro-rata basis.',
      tags: ['payment', 'refund', 'policy']
    },

    // Technical Category
    {
      id: 22,
      category: 'technical',
      question: 'Which platform do you use for live classes?',
      answer: 'We use a custom-built learning management system (LMS) for live classes, recorded lectures, test series, and doubt resolution. You can access it via web browser or our mobile app.',
      tags: ['technical', 'platform', 'app']
    },
    {
      id: 23,
      category: 'technical',
      question: 'Is there a mobile app for Exademy?',
      answer: 'Yes, Exademy has a mobile app available for both Android and iOS devices. You can watch recorded lectures, attempt tests, and track your progress on the go.',
      tags: ['technical', 'app', 'mobile']
    },
    {
      id: 24,
      category: 'technical',
      question: 'What internet speed is required for smooth live classes?',
      answer: 'A minimum of 2 Mbps internet speed is recommended for uninterrupted live classes. For recorded lectures, you can download them and watch offline.',
      tags: ['technical', 'internet', 'speed']
    }
  ];

  // Filter FAQs based on category and search
  const filteredFAQs = faqData.filter(faq => {
    const matchesCategory = activeCategory === 'all' || faq.category === activeCategory;
    const matchesSearch = searchQuery === '' || 
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  const toggleItem = (id) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const getCategoryIcon = (categoryId) => {
    const category = categories.find(cat => cat.id === categoryId);
    return category ? category.icon : '📌';
  };

  return (
    <div className={styles.faqPage}>
      {/* Header */}
      <div className={styles.faqHeader}>
        <div className={styles.container}>
          <h1>Frequently Asked <span className={styles.gradientText}>Questions</span></h1>
          <p>Find answers to common questions about our courses, Mathematics optional, UPSC, BPSC, and more.</p>
        </div>
        <div className={styles.headerWave}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120">
            <path fill="#EDFFF7" fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"></path>
          </svg>
        </div>
      </div>

      <div className={styles.container}>
        {/* Search Section */}
        <div className={styles.searchSection}>
          <div className={styles.searchContainer}>
            <span className={styles.searchIcon}>🔍</span>
            <input
              type="text"
              placeholder="Search questions, topics, or keywords..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={styles.searchInput}
            />
            {searchQuery && (
              <button 
                className={styles.clearSearch}
                onClick={() => setSearchQuery('')}
              >
                ✕
              </button>
            )}
          </div>
        </div>

        <div className={styles.faqGrid}>
          {/* Categories Sidebar */}
          <div className={styles.categoriesSection}>
            <h3>Categories</h3>
            <div className={styles.categoriesList}>
              {categories.map(category => (
                <button
                  key={category.id}
                  className={`${styles.categoryBtn} ${activeCategory === category.id ? styles.activeCategory : ''}`}
                  onClick={() => setActiveCategory(category.id)}
                >
                  <span className={styles.categoryIcon}>{category.icon}</span>
                  <span className={styles.categoryName}>{category.name}</span>
                  <span className={styles.categoryCount}>{category.count}</span>
                </button>
              ))}
            </div>

            <div className={styles.helpCard}>
              <div className={styles.helpIcon}>❓</div>
              <h4>Still have questions?</h4>
              <p>Can't find the answer you're looking for? Our support team is here to help.</p>
              <button className={styles.contactBtn}>
                Contact Support
              </button>
            </div>
          </div>

          {/* FAQ Items */}
          <div className={styles.faqsSection}>
            {filteredFAQs.length > 0 ? (
              <>
                <div className={styles.resultsInfo}>
                  <span className={styles.resultsCount}>{filteredFAQs.length} questions</span>
                  {activeCategory !== 'all' && (
                    <span className={styles.activeCategoryLabel}>
                      {getCategoryIcon(activeCategory)} {categories.find(c => c.id === activeCategory)?.name}
                    </span>
                  )}
                </div>

                <div className={styles.faqList}>
                  {filteredFAQs.map(faq => (
                    <div 
                      key={faq.id} 
                      className={`${styles.faqItem} ${openItems[faq.id] ? styles.faqItemOpen : ''}`}
                    >
                      <button
                        className={styles.faqQuestion}
                        onClick={() => toggleItem(faq.id)}
                      >
                        <div className={styles.questionContent}>
                          <span className={styles.questionIcon}>
                            {getCategoryIcon(faq.category)}
                          </span>
                          <span className={styles.questionText}>{faq.question}</span>
                        </div>
                        <span className={styles.toggleIcon}>
                          {openItems[faq.id] ? '−' : '+'}
                        </span>
                      </button>
                      
                      <div className={`${styles.faqAnswer} ${openItems[faq.id] ? styles.faqAnswerOpen : ''}`}>
                        <div className={styles.answerContent}>
                          <p>{faq.answer}</p>
                          <div className={styles.tags}>
                            {faq.tags.map(tag => (
                              <span 
                                key={tag} 
                                className={styles.tag}
                                onClick={() => setSearchQuery(tag)}
                              >
                                #{tag}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className={styles.noResults}>
                <div className={styles.noResultsIcon}>🔍</div>
                <h3>No questions found</h3>
                <p>We couldn't find any questions matching "{searchQuery}"</p>
                <button 
                  className={styles.clearSearchBtn}
                  onClick={() => {
                    setSearchQuery('');
                    setActiveCategory('all');
                  }}
                >
                  Clear search
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;